import React from 'react';
import Dialog from '@mui/material/Dialog';
import JSONTree from 'react-json-tree';
import './JsonDialog.scss';

export interface JsonDialogProps {
  open: boolean;
  data: object;
  onClose: () => void;
}

/**
 * Renders a dialog that displays JSON data.
 */
export function JsonDialog(props: JsonDialogProps) {
  const { open, data, onClose } = props;
  return (
    <Dialog onClose={onClose} open={open}>
      <div className="json-dialog-container">
        <div className="json-dialog-data-container">
          <JSONTree data={data} sortObjectKeys />
        </div>
      </div>
    </Dialog>
  );
}
